<template>

    <div id="my-quizzes">

        <section class="heading-section" data-aos="fade-in">
            <div class="mx-xl-4 py-2" style="display: flex">
                <div class="heading" style="padding: 0 15px;">
                    <a href="/" class="back"></a>
                    <div class="title">{{ t.__('Moje quizy') }}</div>
                </div>
                <div class="text-right" style="padding: 0 15px; margin-left: auto">
                    <b-button variant="success" @click="synchronize" :disabled="processing" v-text="processing ? t.__('Rozpoczynam synchronizację...') : t.__('Synchronizuj z urządzeniem')" style="margin-bottom: 15px;"></b-button>
                    <my-quizzes-legend class="ml-2"></my-quizzes-legend>
                </div>
            </div>
            <div class="mx-xl-5 buttons">
                <div class="button-change-view list-view" :class="{'active': view === 'list'}" @click="setView('list')">
                    <div class="icon"></div>
                    <div class="name">{{ t.__('Lista') }}</div>
                </div>
                <div class="button-change-view board-view" :class="{'active': view === 'board'}" @click="setView('board')">
                    <div class="icon"></div>
                    <div class="name">{{ t.__('Tablica') }}</div>
                </div>
                <div class="button-delete-wrapper">
                    <div class="button-delete" @click="deleteElements">
                        <div class="name">{{ t.__('Usuń') }}</div>
                        <div class="icon"></div>
                    </div>
                    <my-quizzes-delete-elements-hint></my-quizzes-delete-elements-hint>
                </div>
                <div class="button-add-set" @click="addSet">
                    <div class="name">{{ t.__('Dodaj zestaw') }}</div>
                    <div class="icon"></div>
                </div>
                <div class="button-order">
                    <b-dropdown variant="link" no-caret>
                        <template #button-content>
                            <div class="d-flex align-items-center">
                                <div class="name">{{ t.__('Sortuj według') }}</div>
                                <div class="icon"></div>
                            </div>
                        </template>
                        <b-dropdown-item v-for="sortType in sortTypes" :key="sortType.value" @click="selectedSortType = sortType.value" :active="selectedSortType === sortType.value">{{ sortType.text }}</b-dropdown-item>
                    </b-dropdown>

                </div>
                <div class="search-field">
                    <input type="text" :placeholder="t.__('Wyszukaj')" v-model="searchText">
                </div>
            </div>
        </section>

        <my-quizzes-list-view :sets="filteredSets" v-if="view === 'list'" :selected-sort-type="selectedSortType"></my-quizzes-list-view>

        <my-quizzes-board-view :sets="filteredSets" v-if="view === 'board'" :selected-sort-type="selectedSortType"></my-quizzes-board-view>

        <my-quizzes-set-modal></my-quizzes-set-modal>

        <my-quizzes-game-modal></my-quizzes-game-modal>

        <my-quizzes-delete-elements-modal></my-quizzes-delete-elements-modal>

    </div>

</template>

<script>

export default {

    name: 'MyQuizzes',

    props: {
        setsInput: Array
    },

    data() {
        return {
            eventHub: window.eventHub,
            view: localStorage.getItem('myQuizzesViewMode') ? localStorage.getItem('myQuizzesViewMode') : 'list',
            sortTypes: [
                {
                    value: 'order',
                    text: t.__('Własnej kolejności')
                },
                {
                    value: 'mechanism',
                    text: t.__('Mechanizmów')
                },
                {
                    value: 'name',
                    text: t.__('Nazwy')
                },
                {
                    value: 'creation_date',
                    text: t.__('Daty utworzenia')
                }
            ],
            selectedSortType: 'order',
            searchText: '',
            sets: [],
            processing: false
        }
    },

    computed: {
        filteredSets() {

            if (this.sets === undefined) {
                return [];
            }

            let sets = [];

            if (this.searchText.length > 0) {

                this.sets.forEach(set => {

                    // Check set name match
                    if (set.display_name.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1) {
                        sets.push(set);
                        return;
                    }

                    // Check set games name match
                    let modifiedSet = {};
                    Object.assign(modifiedSet, set);
                    let games = [];
                    set.games.forEach(game => {
                        if (game.display_name.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1) {
                            games.push(game);
                        }
                    });
                    modifiedSet.games = games;
                    if (modifiedSet.games.length > 0) {
                        sets.push(modifiedSet);
                    }

                });

            } else {
                this.sets.forEach(set => {
                    sets.push(set);
                });
            }

            switch (this.selectedSortType) {
                case 'order':
                    sets.forEach(set => {
                        let modifiedSet = {};
                        Object.assign(modifiedSet, set);
                        set.games.sort(function(a, b) {
                            return (a.number_in_order < b.number_in_order) ? -1 : (a.number_in_order > b.number_in_order) ? 1 : 0;
                        });
                    });
                    return sets.sort(function(a, b) {
                        return (a.number_in_order < b.number_in_order) ? -1 : (a.number_in_order > b.number_in_order) ? 1 : 0;
                    });
                case 'mechanism':
                    let mechanismRates = {
                        assoc: 1,
                        carousel: 2,
                        qball: 3,
                        ships: 4
                    }
                    sets.forEach(set => {
                        let modifiedSet = {};
                        Object.assign(modifiedSet, set);
                        set.games.sort(function(a, b) {
                            let rateA = mechanismRates[a.mechanism] !== undefined ? mechanismRates[a.mechanism] : 0;
                            let rateB = mechanismRates[b.mechanism] !== undefined ? mechanismRates[b.mechanism] : 0;
                            return (rateA < rateB) ? -1 : (rateA > rateB) ? 1 : 0;
                        });
                    });
                    return sets;
                case 'name':
                    sets.forEach(set => {
                        let modifiedSet = {};
                        Object.assign(modifiedSet, set);
                        set.games.sort(function(a, b) {
                            return a.display_name.localeCompare(b.display_name);
                        });
                    });
                    return sets.sort(function(a, b) {
                        return a.display_name.localeCompare(b.display_name);
                    });
                case 'creation_date':
                    sets.forEach(set => {
                        let modifiedSet = {};
                        Object.assign(modifiedSet, set);
                        set.games.sort(function(a, b) {
                            let dateA = Date.parse(a.created_at);
                            let dateB = Date.parse(b.created_at);
                            return (dateA < dateB) ? -1 : (dateA > dateB) ? 1 : 0;
                        });
                    });
                    return sets.sort(function(a, b) {
                        let dateA = Date.parse(a.created_at);
                        let dateB = Date.parse(b.created_at);
                        return (dateA < dateB) ? -1 : (dateA > dateB) ? 1 : 0;
                    });
                default:
                    return sets;
            }
        }
    },

    beforeMount() {

        this.sets = this.setsInput;

        this.eventHub.$on('my-quizzes-update-sets' , (sets) => {
            this.sets = sets;
        });

        this.eventHub.$on('my-quizzes-order-changed' , (sets) => {
            this.sets = sets;
            let orderData = sets.map((set, index) => {
                return {
                    output_identification_name: set.output_identification_name,
                    order: (index + 1),
                    games: set.games.map((game, index) => {
                        return {
                            output_identification_name: game.output_identification_name,
                            order: (index + 1)
                        }
                    })
                }
            });
            axios.post('/my-quizzes/update-order', {
                order_data: orderData
            })
                .then(response => {})
                .catch(error => {
                    console.log(error);
                });
        });

    },

    methods: {

        setView(view) {
            this.view = view;
            localStorage.setItem('myQuizzesViewMode', this.view);
        },

        addSet() {
            this.eventHub.$emit('my-quizzes-add-set');
        },

        deleteElements() {
            this.eventHub.$emit('my-quizzes-delete-elements');
        },

        showMechanisms(mechanism) {
            this.eventHub.$emit('my-quizzes-show-mechanisms', mechanism);
        },

        synchronize() {
            this.processing = true;
            axios.post('/my-quizzes/synchronize')
                .then(response => {
                    this.processing = false;
                })
                .catch(error => {
                    console.log(error);
                    this.processing = false;
                });
        }

    }

}
</script>

<style scoped>

</style>
